import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { screenNamespaces, screenResources } from '@ooh/screens/i18n-resources';

import {
  readStoredLanguage,
  writeStoredLanguage,
  type SupportedLanguage,
} from './lib/language-storage';

i18next
  .use(initReactI18next)
  .init({
    lng: readStoredLanguage(),
    fallbackLng: 'pl',
    ns: [...screenNamespaces],
    defaultNS: 'common',
    resources: screenResources,
    interpolation: {
      escapeValue: false,
    },
    initImmediate: false,
  })
  .catch((err: unknown) => {
    console.error('[i18n] init failed:', err);
    throw err;
  });

/** Switches the active language and persists the choice so it survives reload/re-login. */
export function changeLanguage(lng: SupportedLanguage): Promise<void> {
  writeStoredLanguage(lng);
  return i18next.changeLanguage(lng).then(() => undefined);
}

export default i18next;
